module.exports = __webpack_public_path__ + "img/choose.5caf162b.svg";